import { render } from "./copyright-trademark.vue?vue&type=template&id=fa491046&scoped=true"
import script from "./copyright-trademark.vue?vue&type=script&lang=js"
export * from "./copyright-trademark.vue?vue&type=script&lang=js"

import "./copyright.less?vue&type=style&index=0&id=fa491046&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa491046"]])

export default __exports__